import React, {FC} from 'react';

import {Feature} from 'components/feature';
import {REFERER_OFFER} from 'constants/analytics/mentionMe';
import {Greeting} from 'desktop/components/helpers/greeting/greeting';
import {MentionMeBanner} from 'desktop/components/mentionMe/mentionMeBanner';
import {useSendPurchaseAnalyticsForUpsell} from 'desktop/hooks/useSendPurchaseAnalyticsForUpsell/useSendPurchaseAnalyticsForUpsell';

import {useCheckLuxuryItem} from 'hooks/useCheckLuxuryItem/useCheckLuxuryItem';
import {flags} from 'libs/rollout';

import {OrderInfoConnected} from '../orderInfo/orderInfo';
import {RateUsSection} from '../rateUsSection/rateUsSection';
import {SuccessPageRewardsBanner} from '../successPageRewardsBanner/successPageRewardsBanner';
import {UpsellBlockConnected} from '../upsellBlock/upsellBlock';

import s from './orderInfoInTYP.scss';

export type PropType = {
    hasUpgrades: boolean;
};

/**
 * Content for TYP with accessories upsells
 *
 * @param {PropsType} props - component props
 * @constructor
 */
export const OrderInfoInTYP: FC<PropType> = ({hasUpgrades}) => {
    const isLuxuryEnabled = useCheckLuxuryItem(flags.dLuxurySpecialExperience.isEnabled());

    useSendPurchaseAnalyticsForUpsell();
    return (
        <>
            <div className={s.greeting}>
                <Greeting underline>Thank you for your order!</Greeting>
            </div>
            <div className={s.orderInformation}>
                <div className={s.left}>
                    <OrderInfoConnected />
                    {!isLuxuryEnabled && (
                        <>
                            <SuccessPageRewardsBanner />
                            <Feature flag="typMentionMeBanner" platform="desktop">
                                <MentionMeBanner
                                    params={{
                                        implementation: 'popup',
                                        locale: 'en_GB',
                                        situation: 'postpurchase',
                                    }}
                                    integratingType={REFERER_OFFER}
                                />
                            </Feature>
                            <RateUsSection />
                        </>
                    )}
                </div>
                {hasUpgrades && (
                    <div className={s.right}>
                        <UpsellBlockConnected />
                    </div>
                )}
            </div>
        </>
    );
};
